import { getDownloadUrlForCollectionUrl } from '@core/api'
import { httpClient } from '@core/http-client'

export const getCollectionDownloadUrl = async ({
    collectionId,
    signal,
}: {
    collectionId: string
    signal?: AbortSignal
}) => {
    return httpClient.get(getDownloadUrlForCollectionUrl(collectionId), {
        signal,
    })
}
